import styled from 'styled-components'

export const Wrap = styled.div`
  display: flex;
  align-items: center;
  > :last-child {
    margin-top: 3px;
  }
`
